import React ,{useState, useEffect} from 'react';
export default function Testimonials(){
    const [testimonials,setTestimonials] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // sample for filtering staff,. eg. partners or associates etc
    // const pUrl = "https://cms.lizakhan.com/items/staff?filter[position][_eq]=partner&limit=8";
    const tUrl = "https://cms.lizakhan.com/items/testimonials?sort=order";

    useEffect(()=>{
	fetch(tUrl).then(res => res.json()).then(result => {
	    setLoading(true);
	    console.log(result.data);
	    setTestimonials(result.data);
	}).catch(error =>{
	    setLoading(true);
	    setError(error);
	})
    }, []);


    if(error){
	return <div> Error: {error}</div>;
    } else if(!loading){
	return <div>Loading ...</div>;
    } else {

	const pairs = [];
	for (let i = 0; i < testimonials.length; i += 2) {
	    const pair = testimonials.slice(i, i + 2);
	    pairs.push(pair);
	}
	
	return(<main>		   
		   <div className="container px-4 py-5">
		       <h2 className="pb-2 border-bottom">What Our Clients Say</h2>
		       {pairs.map((pair, index) => (
			   <div key={index} className="row my-5 p-4 pb-0 pe-lg-0 pt-lg-5 rounded-3 border shadow-lg">
			       {pair &&  pair.map(item =>
				   <div class="col my-5">
				       <div class="row">
					   <div class="col-lg-8">
					       <h4 class="lh-1 fw-bold">{item.from}</h4>
					       <p class="lead">{item.company}</p>
					       <p class="testimonial">{item.testimonial}</p>
					   </div>
					   <div class="col-lg-4">				       
					       <img class="my-3 rounded-3" src={"https://cms.lizakhan.com/assets/"+item.photo} alt="" width="100px" />
					   </div>
				       </div>
				   </div>
			       )}
			   </div>
		       ))}
		   </div>
	       </main>)
    }
}
